module.exports = "/shared/img/rubbish.svg";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/rubbish.svg
// module id = 448
// module chunks = 13